module.exports = __webpack_public_path__ + "static/iot-system-2-8a938625e2e4f03755a6861cd738158a.png";